const IntercomHelpIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => {
  return (
    <svg viewBox="11.059 9.048 20.038 19.973" fill="none" {...props}>
      <g filter="url(#filter0_d_8382_2218)">
        <rect x={12} y={10} width={18} height={18} rx={9} fill="#8065C9" />
        <path
          d="M25.103 23.636s-1.417-.538-2.564-.97h-4.822c-.57 0-1.033-.474-1.033-1.058v-6.204c0-.584.462-1.058 1.033-1.058h6.352c.57 0 1.034.474 1.034 1.058v8.233zm-1.245-3.479a.271.271 0 00-.388-.03c-.01.008-.907.779-2.577.779-1.65 0-2.561-.766-2.578-.78a.271.271 0 00-.388.031.287.287 0 00.03.398c.043.038 1.064.915 2.936.915 1.872 0 2.893-.877 2.935-.915a.287.287 0 00.03-.398z"
          fill="#fff"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_8382_2218"
          x={0}
          y={0}
          width={42}
          height={42}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={6} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_8382_2218"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_8382_2218"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default IntercomHelpIcon;
